import React, { useState, useEffect, useRef } from "react";
import "../components/SearchBar.css";
import { FiSearch } from "react-icons/fi";

export default function SearchBar() {
  const API_BASE =
    "https://oaxxy2qi6afzv46h2rkvpspkyi0apxxs.lambda-url.us-east-2.on.aws/";
  const [allItems, setAllItems] = useState([]);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const wrapperRef = useRef(null);

  // 1) Fetch every item once on mount
  useEffect(() => {
    fetch(API_BASE)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((items) => setAllItems(items))
      .catch((e) => console.error("Failed to load items:", e));
  }, []);

  // 2) Filter in‑memory whenever `query` changes
  useEffect(() => {
    const q = query.trim().toLowerCase();
    if (!q) {
      setSuggestions([]);
      return;
    }
    const matches = allItems.filter((item) =>
      item.product_name.toLowerCase().includes(q)
    );
    setSuggestions(matches);
  }, [query, allItems]);

  // 3) Hide dropdown on outside click
  useEffect(() => {
    const onClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="searchbar" ref={wrapperRef}>
      <input
        type="text"
        className="searchbar_input"
        placeholder="Search items…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <button
        className="searchbar_button"
        onClick={() => {
          if (suggestions[0]) window.open(suggestions[0].link, "_blank");
        }}
        aria-label="Search"
      >
        <FiSearch className="searchbar__icon" size={20} />
      </button>

      {suggestions.length > 0 && (
        <ul className="searchbar_suggestions">
          {suggestions.map((item) => (
            <li
              key={item.SK}
              className="suggestion_item"
              onClick={() => window.open(item.link, "_blank")}
            >
              <img
                src={item.image_url.replace(/w=\d+(?:&sh=\d+)?/g, "w=60&sh=60")}
                alt={item.product_name}
                className="suggestion_image"
              />
              <span className="suggestion_text">{item.product_name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
